<template>
  <svg
    t="1658460787971"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4938"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="200"
    height="200"
  >
    <path
      d="M872.448 872.6016h-151.6544v-237.568c0-56.6784-1.1776-129.5872-79.0528-129.5872-79.0528 0-91.136 61.6448-91.136 125.3888v241.7664H399.0016V384h145.6128v66.56h1.9968c20.3264-38.4 69.8368-78.848 143.7696-78.848 153.6512 0 182.0672 101.0688 182.0672 232.704v268.1856zM227.6864 317.1328c-48.8448 0-88.064-39.4752-88.064-88.064s39.2704-88.064 88.064-88.064a88.064 88.064 0 0 1 0 176.128z m75.9808 555.52h-152.064V384h152.064v488.6016zM948.2752 0H75.5712C33.792 0 0 33.024 0 73.728v876.544C0 990.976 33.792 1024 75.5712 1024h872.5504c41.728 0 75.8784-32.9728 75.8784-73.728V73.728C1024 33.0752 989.8496 0 948.1216 0h0.1536z"
      fill="#0A66C2"
      p-id="4939"
    ></path>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'LinkedIn'
});
</script>
